import { render, staticRenderFns } from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=template&id=ac79da26&scoped=true&"
import script from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=script&lang=js&"
export * from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentInterviewQuestionMultiChoice.vue?vue&type=style&index=0&id=ac79da26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac79da26",
  null
  
)

export default component.exports